export const NEWSLETTER_REGISTRATION_REQUEST = 'newsletter/NEWSLETTER_REGISTRATION_REQUEST';
export const NEWSLETTER_REGISTRATION_SUCCESS = 'newsletter/NEWSLETTER_REGISTRATION_SUCCESS';

export const LIGHT_MEMBER_REGISTRATION_REQUEST = 'newsletter/LIGHT_MEMBER_REGISTRATION_REQUEST';
export const LIGHT_MEMBER_REGISTRATION_SUCCESS = 'newsletter/LIGHT_MEMBER_REGISTRATION_SUCCESS';
